import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class AdvancePaymentProofResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'order_number': 'ORD-001',
                'file': { 'name': 'comprobante.pdf', 'url': '/media/advance_payment_proofs/comprobante.pdf' },
                'creation_datetime': '01-01-2024 10:30:00'
            },
            errors: []
        }
    }

    advancePaymentProof() {
        const proof = this.content();

        if (!proof || Object.keys(proof).length === 0) {
            return null;
        }

        const file = proof.file;
        return {
            orderNumber: proof.order_number,
            file: { name: file.name, url: file.url },
            creationDateTime: proof.creation_datetime
        }
    }
} 